import { Customer } from './Customer/Customer';

export interface ICustomerCreditCheckNameEqualityRecord {
    customerCreditCheckNameId: number;
    customerId: number;
    requestFirstName: string;
    requestLastName: string;
    requestGeneration: string;
    returnedFirstName: string;
    returnedLastName: string;
    returnedGeneration: string;
    approvedBy: string;
    createDate: Date;
    createBy: string;
    modifyDate: Date;
    modifyBy: string;
}

export class CustomerCreditCheckNameEqualityRecord implements ICustomerCreditCheckNameEqualityRecord {
    customerCreditCheckNameId: number;
    customerId: number;
    requestFirstName: string;
    requestLastName: string;
    requestGeneration: string;
    returnedFirstName: string;
    returnedLastName: string;
    returnedGeneration: string;
    approvedBy: string;
    createDate: Date;
    createBy: string;
    modifyDate: Date;
    modifyBy: string;
}